import React from "react";

const StandardTable = ({ children }) => {
  return (
    <table className="w-100 table__wrapper tc" cellSpacing="0">
      {children}
      <style jsx>{`
        .table__wrapper > td {
          padding: 20px;
        }
      `}</style>
    </table>
  );
};

export default StandardTable;
